import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { SwitchInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SwitchInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SwitchInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SwitchInput_SwitchInput = (t0)=>{
    const $ = c(18);
    let disabled;
    let label;
    let labelIcon;
    let labelPlacement;
    let onChange;
    let rest;
    let tooltip;
    if ($[0] !== t0) {
        ({ label, labelIcon, onChange, disabled, labelPlacement, tooltip } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "onChange",
            "disabled",
            "labelPlacement",
            "tooltip"
        ]);
        $[0] = t0;
        $[1] = disabled;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = labelPlacement;
        $[5] = onChange;
        $[6] = rest;
        $[7] = tooltip;
    } else {
        disabled = $[1];
        label = $[2];
        labelIcon = $[3];
        labelPlacement = $[4];
        onChange = $[5];
        rest = $[6];
        tooltip = $[7];
    }
    let t1;
    if ($[8] !== disabled || $[9] !== label || $[10] !== labelIcon || $[11] !== labelPlacement || $[12] !== onChange || $[13] !== tooltip) {
        t1 = (t2)=>{
            const { input } = t2;
            return /*#__PURE__*/ jsx(SwitchInput, _object_spread_props(_object_spread({}, input), {
                checked: !!input.value,
                label: label,
                labelIcon: labelIcon,
                onChange: (check)=>{
                    input.onChange(check);
                    if (onChange) onChange(check);
                },
                disabled: disabled,
                labelPlacement: labelPlacement,
                tooltip: tooltip
            }));
        };
        $[8] = disabled;
        $[9] = label;
        $[10] = labelIcon;
        $[11] = labelPlacement;
        $[12] = onChange;
        $[13] = tooltip;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== rest || $[16] !== t1) {
        t2 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({}, rest), {
            children: t1
        }));
        $[15] = rest;
        $[16] = t1;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
};
export { SwitchInput_SwitchInput as SwitchInput };
